<template>
    <div>
        <a :href="url" @click.prevent="select">
            <div
                class="mb-3 shop-product-card text-center shadow bg-white"
                :class="{ highlighted: highlighted, 'pt-5': !smallerView, 'pb-5': !smallerView }"
            >
                <input name="selectedProductType" :value="type" hidden />
                <h2 class="title text-uppercase" :class="{ 'mb-4': !smallerView }">{{ $t('shop.toll-product') }}</h2>
                <div v-if="showPrice" class="d-flex justify-content-center" :class="{ 'mb-4': !smallerView }">
                    <span v-if="highlighted && configValue > 0" class="price h1 mb-0"
                        >{{ configValue.toFixed(2) }} €</span
                    >
                    <span
                        v-if="!highlighted"
                        class="price h3 mb-0"
                        v-html="
                            $t('shop.starting_at', {
                                price: minPrice,
                            })
                        "
                    ></span>
                </div>
                <p v-if="!smallerView" class="text-quote">{{ $t('frontend.section_pricing_product_2_description') }}</p>
                <a :href="url" class="btn btn-primary mt-4">{{ $t('shop.buy') }}</a>
            </div>
        </a>
    </div>
</template>

<script>
import ProductCard from './ProductCard.vue';

export default {
    extends: ProductCard,
    props: ['id', 'duration', 'is_validity_controllable', 'options', 'startPrice', 'urlName'],
    data() {
        return {
            type: 'route_toll',
        };
    },
    computed: {
        highlighted() {
            return this.selectedProductType === this.type;
        },
        minPrice() {
            return parseFloat(this.startPrice).toFixed(2) + '&nbsp;€';
        },
        url() {
            if (!this.urlName) {
                return '#';
            }
            return '/' + this.$language + '/shop/' + this.urlName;
        },
    },

    mounted() {
        if (this.preselectId) {
            this.select();
        }
    },
};
</script>
